import request from '@/utils/axios'

// 获取币种简介
export function coinIntroduction(query) {
  return request({
    url: '/member/assets/wallet/coinInfo',
    method: 'get',
    params: query
  })
}

// 获取所有交易对行情
export function fetchAllQuote() {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/data/allQuote`,
    method: 'get'
  })
}

// 获取汇率
export function fetchRate() {
  return request({
    url: '/trade/getRate',
    method: 'post'
  })
}

// 获取推荐交易对
export function fetchRecommendTradingPair() {
  return request({
    url: '/token/recommend',
    method: 'get'
  })
}
